<template>
  <div v-if="expandido || !precisaTruncar" :class="conteudoClasse" v-html="textoExibicao"></div>
  <div v-else :class="conteudoClasse">
    {{ textoResumido }}
    <a
      href="#"
      class="manifestacao-mensagem-ver-tudo"
      role="button"
      @click.prevent="expandido = true"
      >Ver tudo</a
    >
  </div>
</template>

<script>
import {
  LIMITE_CARACTERES_MENSAGEM,
  mensagemPrecisaTruncar,
  mensagemTextoResumido,
} from '@/utils/manifestacaoMensagem';

export default {
  name: 'ManifestacaoMensagemTexto',
  props: {
    texto: {
      type: String,
      default: '',
    },
    conteudoClasse: {
      type: String,
      default: 'content message',
    },
    limiteCaracteres: {
      type: Number,
      default: LIMITE_CARACTERES_MENSAGEM,
    },
  },
  data() {
    return {
      expandido: false,
    };
  },
  computed: {
    textoExibicao() {
      if (this.texto == null) return '';
      return String(this.texto);
    },
    precisaTruncar() {
      return mensagemPrecisaTruncar(this.textoExibicao, this.limiteCaracteres);
    },
    textoResumido() {
      return mensagemTextoResumido(this.textoExibicao, this.limiteCaracteres);
    },
  },
  watch: {
    texto() {
      this.expandido = false;
    },
  },
};
</script>
